import "../../styles/BlogPage.css";

export default function BlogPreview({ blog, onClick }) {
  // Prevent errors if blog isn't loaded yet
  if (!blog) return null;
  // Format date as MM/DD/YYYY, safely for iOS
  function formatDate(dateString) {
    if (!dateString) return "";

    // iOS-safe handling: convert YYYY-MM-DD → YYYY/MM/DD
    const safeString = dateString.replace(/-/g, "/");

    const d = new Date(safeString);
    if (isNaN(d)) return dateString;

    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();

    return `${month}/${day}/${year}`;
  }


  const stripHtml = (html) =>
    (html || "").replace(/<[^>]+>/g, "").slice(0, 140) + "...";

  const imageSrc =
    blog?.image
      ? blog.image.includes("?")
        ? `${blog.image}&raw=1`
        : `${blog.image}?raw=1`
      : "https://via.placeholder.com/400x250?text=No+Image";

  return (
    <div className="blogCard" onClick={onClick}>
      <img
        className="blogCardImage"
        src={imageSrc}
        alt={blog?.title || "Untitled"}
      />

      <div className="blogCardBody">
        <h3 className="blogCardTitle">{blog.title}</h3>
        <p className="blogCardDate">{formatDate(blog.date)}</p>
        <p className="blogCardSnippet">
          {stripHtml(blog.content)}
        </p>
      </div>
    </div>
  );
}
